import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { allLangs } from '../locales';

const LanguageSelector = ({ isMobile = false }) => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef(null);

  const currentLang = allLangs.find((lang) => lang.value === i18n.language) || allLangs[0];

  const handleChangeLang = (langValue) => {
    i18n.changeLanguage(langValue);
    setIsOpen(false);
  };

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  // Close on escape key
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen]);

  return (
    <>
      {/* Flag button trigger */}
      <button
        onClick={() => setIsOpen(true)}
        className="lang-flag-btn"
        aria-label="Select language"
      >
        <img
          src={`/img/flags/${currentLang.value}.svg`}
          alt={currentLang.label}
          className="lang-flag-img"
        />
      </button>

      {/* Modal/Popup overlay */}
      {isOpen && (
        <div className="lang-modal-overlay">
          <div className="lang-modal" ref={modalRef}>
            <button className="lang-modal-close" onClick={() => setIsOpen(false)}>
              <i className="fa fa-times"></i>
            </button>
            <h3 className="lang-modal-title">{t('nav.selectLanguage')}</h3>
            <div className="lang-options">
              {allLangs.map((lang) => (
                <button
                  key={lang.value}
                  onClick={() => handleChangeLang(lang.value)}
                  className={`lang-option ${currentLang.value === lang.value ? 'active' : ''}`}
                >
                  <img
                    src={`/img/flags/${lang.value}.svg`}
                    alt={lang.label}
                    className="lang-option-flag"
                  />
                  <span className="lang-option-name">{lang.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LanguageSelector;
